// extracted by mini-css-extract-plugin
export default {"burger":"BurgerButton_burger__xjIzg"};